'use client';

import * as React from 'react';
import { cn } from '@/lib/utils';

type AvatarSize = 'sm' | 'md' | 'lg' | 'xl';

export interface MHAvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  src?: string;
  alt?: string;
  name?: string;
  size?: AvatarSize;
}

function getInitials(name?: string) {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).slice(0, 2);
  return parts.map((part) => part[0]?.toUpperCase() ?? '').join('');
}

export function MHAvatar({ src, alt, name, size = 'md', className, ...props }: MHAvatarProps) {
  const [failed, setFailed] = React.useState(false);
  const initials = getInitials(name);

  return (
    <div
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-surface-2 text-text-2',
        size === 'sm' && 'h-8 w-8 text-[12px]',
        size === 'md' && 'h-10 w-10 text-[13px]',
        size === 'lg' && 'h-12 w-12 text-[15px]',
        size === 'xl' && 'h-16 w-16 text-[18px]',
        className
      )}
      {...props}
    >
      {src && !failed ? (
        <img src={src} alt={alt ?? name ?? 'Avatar'} onError={() => setFailed(true)} className="h-full w-full object-cover" />
      ) : (
        <span className="font-medium">{initials}</span>
      )}
    </div>
  );
}
